import { BTable, BFormGroup, BFormInput, BFormCheckbox } from "bootstrap-vue";
import Loading from "@@/core/components/shared/Loading/Loading";
import ImageHolder from "@@/core/components/shared/ImageHolder/ImageHolder";

export default {
  name: "SellerDetail",
  components: {
    Loading,
    ImageHolder,
    BTable,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
  },
  data() {
    return {
      seller: null,
      sellerRequests: [],
      id: this.$route.params.id,
      page: 1,
      previousPage: 1,
      per_page: 40,
      productSku: "",
      disabled: true,
      filterBtns: [
        {
          title: "همه",
          id: 1,
          status: "all",
          active: true,
          style: "badge badge-success status border-none",
        },
        {
          title: "جدید",
          id: 2,
          status: "pending",
          active: false,
          style: "badge badge-warning status border-none",
        },
        {
          title: "ارسال شده",
          id: 3,
          status: "sent",
          active: false,
          style: "badge badge-secondary status border-none",
        },
        {
          title: "فروخته شده",
          id: 4,
          status: "sold",
          active: false,
          style: "badge badge-success status border-none",
        },
        {
          title: "بررسی شده",
          id: 5,
          status: "checked",
          active: false,
          style: "badge badge-info status border-none",
        },
        {
          title: "برگشت داده شده",
          id: 6,
          status: "returned",
          active: false,
          style: "badge badge-danger status border-none",
        },
      ],
      filterActive: "all",
      loader: false,
    };
  },
  watch: {
    per_page() {
      this.changePage(1);
    },
  },
  mounted() {
    if (this.$route.query.status) {
      this.filterActive = this.$route.query.status;
    }
    this.loadData();
  },
  methods: {
    filterStatus(filter) {
      this.filterActive = filter.status;
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, status: filter.status },
      });
      this.filterBtns.forEach((item) => {
        if (item.status == filter.status) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      this.loadData();
    },
    async requestProduct() {
      try {
        this.disabled = true;
        let fd = new FormData();
        fd.append(`barcodes[0]`, this.productSku);
        const response = await this.$axios.post(
          "admin/change-status-seller-requests-to-complete",
          fd,
        );
        this.$root.notify(response.data.message, "success");
        window.location.reload();
        this.productSku = "";
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    numberListItem(list) {
      if (list && list.length) {
        let items = list.filter((item) => item.status == "pending");
        return items.length;
      } else {
        return "0";
      }
    },
    async loadData() {
      try {
        this.disabled = true;
        this.loader = true;
        let params = {
          page: this.page,
          per_page: this.per_page,
        };
        if (this.filterActive != null && this.filterActive != "all") {
          params.status =
            this.filterActive != null && this.filterActive != "all"
              ? this.filterActive
              : "";
        }
        const response = await await this.$axios.get(
          `admin/seller-requests/${this.id}`,
          {
            params: params,
          },
        );
        this.seller = response.data.data.seller;
        this.sellerRequests = response.data.data.requests;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.loader = false;
        this.$nextTick(() => {
          const input = this.$refs.productSku?.$el || this.$refs.productSku;
          input?.focus();
        });
      }
    },
  },
  watch: {
    disabled(val) {
      if (!val) {
        this.$nextTick(() => {
          const input = this.$refs.productSku?.$el || this.$refs.productSku;
          input?.focus();
        });
      }
    },
  },
};
